import { defineQuery } from 'next-sanity'

export const postCardBlockFields = `
  _id,
  _type,
  title,
  items[]->{
    _id,
    _type,
    title,
    "slug": slug.current,
    mainImage {
      asset,
      altText,
      hotspot,
      crop
    },
    description,
    "excerpt": pt::text(body[0...2]),
    "categories": categories[]->title
  }
`

export const POST_CARD_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "post-card-block"][0]{
    ${postCardBlockFields}
  }
`)
